var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.809 20.64H5.945c-.6 0-1.085-.486-1.085-1.086v-8.541c0-.6.486-1.087 1.085-1.087H17.81c.6 0 1.086.487 1.086 1.087v8.541c0 .6-.486 1.086-1.086 1.086",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.809 20.64H5.945c-.6 0-1.085-.486-1.085-1.086v-8.541c0-.6.486-1.087 1.085-1.087H17.81c.6 0 1.086.487 1.086 1.087v8.541c0 .6-.486 1.086-1.086 1.086z",
    stroke: "#666",
    fill: "#666",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.159 12.507h9.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M7.159 12.507h9.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.159 14.952h9.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M7.159 14.952h9.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.158 17.456a.603.603 0 11-1.207 0 .603.603 0 011.207 0M15.052 17.456a.603.603 0 11-1.206 0 .603.603 0 011.206 0M7.777 3.36s-1.608.693-.396 2.018c.701.766.659 1.724-.519 2.06",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.777 3.36s-1.608.693-.396 2.018c.701.766.659 1.724-.519 2.06",
    stroke: "#666",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4 3.36s-1.608.693-.396 2.018c.7.766.659 1.724-.52 2.06",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4 3.36s-1.608.693-.396 2.018c.7.766.659 1.724-.52 2.06",
    stroke: "#666",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.023 3.36s-1.609.693-.396 2.018c.7.766.658 1.724-.52 2.06",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.023 3.36s-1.609.693-.396 2.018c.7.766.658 1.724-.52 2.06",
    stroke: "#666",
    strokeLinecap: "round"
  })))));
}
export default SvgHeater;